import {DateRange, SelectComponent, UnifiedInventoryMovementState} from "../../../interfaces/unifiedInventoryMovementInterfaces";
import {
    RESET_SEARCH_RESULT_COUNT,
    RESET_SEARCH_TABLE_ITEMS,
    SEARCH_API_CALL_NEEDED, UPDATE_ACTIVE_DRAWER,
    UPDATE_CURRENT_PAGE_INDEX,
    UPDATE_DESCENDING_SORTING,
    UPDATE_DESTINATION_LOCATION_NAMES_MORE_FILTERS,
    UPDATE_EMPTY_FILTER_STATE,
    UPDATE_FILTER_ITEM_COUNT,
    UPDATE_INVENTORY_CATEGORY_OPTIONS,
    UPDATE_PREFERENCES,
    UPDATE_PROJECT_TAG_OPTIONS,
    UPDATE_SEARCH_REQUEST,
    UPDATE_SEARCH_RESULT_COUNT,
    UPDATE_SEARCH_TABLE_ITEMS,
    UPDATE_SEARCH_TEXT,
    UPDATE_SELECTED_CREATION_DATE_RANGE, UPDATE_SELECTED_DESTINATIONS,
    UPDATE_SELECTED_INVENTORY_CATEGORY, UPDATE_SELECTED_NEED_BY_DATE_RANGE,
    UPDATE_SELECTED_PRIORITY, UPDATE_SELECTED_PROJECT_TAG, UPDATE_SELECTED_SOURCE,
    UPDATE_SELECTED_STATE,
    UPDATE_SORTING_COLUMN, UPDATE_SOURCE_LOCATION_NAMES, UPDATE_SELECTED_SEGMENT_ID, UPDATE_SELECTED_TRACKING_STAGES
} from "../types/unifiedInventoryMovementTypes";
import {
    COLUMN_DEFINITIONS,
    DEFAULT_PREFERENCES
} from "../../../pages/UnifiedMovementSystem/UnifiedInventoryMovement/config/UnifiedInventoryMovementTableConfig";
import {UnifiedInventoryMovementActions} from "../actions/unifiedInventoryMovementActions";
import {SearchWorkOrdersRequest} from "../../../interfaces/SearchWorkOrdersInterface";
import {PaginationType} from "../../../interfaces/inventoryViewCommon";

const searchRequest: SearchWorkOrdersRequest = {
    searchCriteria: {},
    sortCriteria: [],
    paginationType: PaginationType.OFFSET_BASED,
    maxResults: 0,
    nextToken: ""
}

const initialState: UnifiedInventoryMovementState= {
    searchResultCount: 0,
    preferences: DEFAULT_PREFERENCES,
    searchTableItems: [],
    sortingColumn: COLUMN_DEFINITIONS[3],
    descendingSorting: true,
    emptyFilter: false,
    searchText: "",
    selectedCreationDateRange: {},
    currentPageIndex: 1,
    searchApiCallNeeded: false,
    searchRequest: searchRequest,
    selectedFilterItemCount: 0,
    selectedState: [],
    selectedPriority: { label: "Any", value: "any" },
    selectedInventoryCategory: [],
    selectedProjectTag: [],
    selectedSource: [],
    selectedDestinations: [],
    selectedTrackingStages: [],
    selectedNeedByDateRange: {},
    activeDrawer: null,
    sourceLocationNames: [],
    projectTagOptions: [],
    destinationLocationNamesMoreFilters: [],
    inventoryCategoryOptions: [],
    selectedSegmentId: "all",
}
export const unifiedInventoryMovementReducer =
    (state = initialState, action: UnifiedInventoryMovementActions) : UnifiedInventoryMovementState =>{
        switch (action.type) {
            case UPDATE_SEARCH_RESULT_COUNT:
                return {
                    ...state,
                    searchResultCount: action.payload as number
                }
            case RESET_SEARCH_RESULT_COUNT:
                return {
                    ...state,
                    searchResultCount: 0
                }
            case UPDATE_PREFERENCES:
                return {
                    ...state,
                    preferences: action.payload as any
                }
            case UPDATE_SEARCH_TABLE_ITEMS:
                return {
                    ...state,
                    searchTableItems: action.payload as any[]
                }
            case RESET_SEARCH_TABLE_ITEMS:
                return {
                    ...state,
                    searchTableItems: []
                }
            case UPDATE_SORTING_COLUMN:
                return {
                    ...state,
                    sortingColumn: action.payload as any
                }
            case UPDATE_DESCENDING_SORTING:
                return {
                    ...state,
                    descendingSorting: action.payload as boolean
                }
            case UPDATE_EMPTY_FILTER_STATE:
                return {
                    ...state,
                    emptyFilter: action.payload as boolean
                }
            case UPDATE_SEARCH_TEXT:
                return {
                    ...state,
                    searchText: action.payload as string
                }
            case UPDATE_SELECTED_CREATION_DATE_RANGE:
                return {
                    ...state,
                    selectedCreationDateRange: action.payload as DateRange
                }
            case UPDATE_CURRENT_PAGE_INDEX:
                return {
                    ...state,
                    currentPageIndex: action.payload as number
                }
            case SEARCH_API_CALL_NEEDED:
                return {
                    ...state,
                    searchApiCallNeeded: action.payload as boolean
                }
            case UPDATE_SEARCH_REQUEST:
                return {
                    ...state,
                    searchRequest: action.payload as SearchWorkOrdersRequest
                }
            case UPDATE_FILTER_ITEM_COUNT:
                return {
                    ...state,
                    selectedFilterItemCount: action.payload as number
                }
            case UPDATE_SELECTED_STATE:
                return {
                    ...state,
                    selectedState: action.payload as SelectComponent[]
                }
            case UPDATE_SELECTED_PRIORITY:
                return {
                    ...state,
                    selectedPriority: action.payload as SelectComponent
                }
            case UPDATE_SELECTED_INVENTORY_CATEGORY:
                return {
                    ...state,
                    selectedInventoryCategory: action.payload as SelectComponent[]
                }
            case UPDATE_SELECTED_PROJECT_TAG:
                return {
                    ...state,
                    selectedProjectTag: action.payload as SelectComponent[]
                }
            case UPDATE_SELECTED_SOURCE:
                return {
                    ...state,
                    selectedSource: action.payload as SelectComponent[]
                }
            case UPDATE_SELECTED_DESTINATIONS:
                return {
                    ...state,
                    selectedDestinations: action.payload as SelectComponent[]
                }
            case UPDATE_SELECTED_TRACKING_STAGES:
                return {
                    ...state,
                    selectedTrackingStages: action.payload as SelectComponent[]
                }    
            case UPDATE_SELECTED_NEED_BY_DATE_RANGE:
                return {
                    ...state,
                    selectedNeedByDateRange: action.payload as DateRange
                }
            case UPDATE_ACTIVE_DRAWER:
                return {
                    ...state,
                    activeDrawer: action.payload as string
                }
            case UPDATE_SOURCE_LOCATION_NAMES:
                return {
                    ...state,
                    sourceLocationNames: action.payload as SelectComponent[]
                }
            case UPDATE_PROJECT_TAG_OPTIONS:
                return {
                    ...state,
                    projectTagOptions: action.payload as SelectComponent[]
                }
            case UPDATE_DESTINATION_LOCATION_NAMES_MORE_FILTERS:
                return {
                    ...state,
                    destinationLocationNamesMoreFilters: action.payload as SelectComponent[]
                }
            case UPDATE_INVENTORY_CATEGORY_OPTIONS:
                return {
                    ...state,
                    inventoryCategoryOptions: action.payload as SelectComponent[]
                }
            case UPDATE_SELECTED_SEGMENT_ID:
                return {
                    ...state,
                    selectedSegmentId: action.payload as string
                }
            default:
                return state;
        }
    }